import { createStore, createHook, createContainer } from 'react-sweet-state';
import { actions } from './actions';
import { getAssociatedIssues } from './selectors';
import type { State, ContainerProps, StoreApi } from './types';

export const AssociatedIssuesContainer = createContainer<ContainerProps>();

const handlers = {
	onInit: () => (storeApi: StoreApi) => {
		storeApi.dispatch(actions.loadAssociatedIssue());
	},
	onContainerUpdate: () => () => {
		// at this point associated issues are read-only, so we don't fetch anything here
	},
};

const Store = createStore<State, typeof actions, ContainerProps>({
	containedBy: AssociatedIssuesContainer,
	initialState: {
		associatedIssues: undefined,
		isError: false,
		isLoading: false,
	},
	actions,
	handlers,
});

export const useAssociatedIssues = createHook(Store, {
	selector: getAssociatedIssues,
});
